import type {
  ConnectionPreviewSlice,
  ConnectionPreviewState,
  PreviewMeshTransform,
  ViewerSliceCreator,
} from "./types";

export const connectionPreviewInitialState: ConnectionPreviewState = {
  showConnectionPreview: false,
  previewChildInstanceId: null,
  previewMeshTransforms: {},
  hoverConnectionTarget: null,
};

export const createConnectionPreviewSlice: ViewerSliceCreator<ConnectionPreviewSlice> = (set) => ({
  ...connectionPreviewInitialState,

  setConnectionPreview: (msg) =>
    set((state) => {
      state.showConnectionPreview = msg.show_preview;
      state.previewChildInstanceId = msg.child_instance_id;
      // Convert mesh transforms array to Record for easy lookup
      const transforms: Record<string, PreviewMeshTransform> = {};
      if (msg.mesh_transforms) {
        for (const t of msg.mesh_transforms) {
          transforms[t.uuid] = {
            position: t.position,
            quaternion: t.quaternion,
          };
        }
      }
      state.previewMeshTransforms = transforms;
    }),

  setHoverConnectionTarget: (target) =>
    set((state) => {
      state.hoverConnectionTarget = target;
    }),
});
